export default __webpack_public_path__ + "static/media/funder_logos.4a197314.jpeg";